import { combineReducers } from '@reduxjs/toolkit';
import editAssessmentReducer from '../features/editAssessment/editAssessmentSlice';
import sweetAlertReducer from '../features/sweetAlert/sweetAlertSlice';
import chatBotReducer from '../features/chat/chatbotSlice';
import intakeFormReducer from '../features/intakeForm/intakeFormSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import directToConsumerReducer from '../features/directToConsumer/directToConsumerSlice';
import paymentStatusPopupReducer from '../features/paymentStatusPopup/paymentStatusPopupSlice';
import purchasePackageReducer from '../features/purchasePackage/purchasePackageSlice';
import askEmmaReducer from '../features/askEmma/askEmmaSlice';
import chatBotNewReducer from '../features/chatbotNew/chatbotNewSlice';
import tenantFeaturesReducer from '../features/tenantFeatures/tenantFeaturesSlice';

const rootReducer = combineReducers({
    editAssessment: editAssessmentReducer,
    sweetAlert: sweetAlertReducer,
    chatBot: chatBotReducer,
    intakeForm: intakeFormReducer,
    dashboard: dashboardReducer,
    directToConsumer: directToConsumerReducer,
    paymentStatusPopup: paymentStatusPopupReducer,
    purchasePackage: purchasePackageReducer,
    askEmma: askEmmaReducer,
    chatBotNew: chatBotNewReducer,
    tenantFeatures: tenantFeaturesReducer,
});

export default rootReducer;
